import { GlobalStatus } from "@gtpl/shared-models/common-models";
import { SaleOrderDropDownDto } from "../sale-order-drop-down.dto";
import { SaleOrder } from "./so-details.dto";

export class SoFormSdfPrintDto {

    saleOrderId?: number;


    constructor(
 
        saleOrderId?:number,

        ){

      this.saleOrderId = saleOrderId;

    }
  }